import { render, staticRenderFns } from "./ReviewWriteble.vue?vue&type=template&id=3b35f8c0&scoped=true"
import script from "./ReviewWriteble.vue?vue&type=script&lang=js"
export * from "./ReviewWriteble.vue?vue&type=script&lang=js"
import style0 from "./ReviewWriteble.vue?vue&type=style&index=0&id=3b35f8c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b35f8c0",
  null
  
)

export default component.exports